import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SchoolCoursesService } from '@digilize/language-school/data';
import { Group, QuizSessionScore } from '@digilize/shared/definitions/src';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'lsl-exercise-exam-result',
  templateUrl: './exercise-exam-result.component.html',
  styleUrls: ['./exercise-exam-result.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ExerciseExamResultComponent implements OnInit {
  @Input() isExam: boolean;
  @Input() quizSessionScore: QuizSessionScore;
  lessonGroup$: Observable<Group>;
  constructor(
    private schoolCoursesService: SchoolCoursesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    const lessonId = this.route.snapshot.paramMap.get('lessonId');

    this.lessonGroup$ = this.schoolCoursesService.getLesson(lessonId).pipe(
      map((lesson) => {
        return lesson.groups[0];
      })
    );
  }
}
